import { WidgetModel } from './widget.model';

export class SiteMapWidgetModel extends WidgetModel {}
